import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormikContext } from "formik";
import { useCallback, useEffect, useRef, useState } from "react";
import { Selector, SelectorContent, SelectorTrigger } from "../../../components/Select/Selector/Index";
import { SelectedRouteDisplay } from "./Routes";
import useFormRoutes from "../../../hooks/useFormRoutes";
import Balance from "../Amount/Balance";
import { Content } from "./Content";
import PickerWalletConnect from "./RouterPickerWalletConnect";
import { swapInProgress } from "../../../components/utils/swapUtils";
import { updateForm } from "../../../components/Pages/Swap/Form/updateForm";
import clsx from "clsx";
import useSuggestionsLimit from "../../../hooks/useSuggestionsLimit";
import useWallet from "../../../hooks/useWallet";
const RoutePicker = ({ direction, isExchange = false, className, minAllowedAmount, maxAllowedAmount, quote, quoteTokenPrices, hideBalance = false, onTriggerClick }) => {
    const { values, setFieldValue, } = useFormikContext();
    const [searchQuery, setSearchQuery] = useState("");
    const { wallets } = useWallet();
    const ref = useRef(null);
    const { suggestionsLimit } = useSuggestionsLimit({ hasWallet: wallets.length > 0, });
    const { allRoutes, isLoading, routeElements, selectedRoute, selectedToken } = useFormRoutes({ direction, values }, searchQuery, suggestionsLimit);
    const currencyFieldName = direction === 'from' ? 'fromAsset' : 'toAsset';
    useEffect(() => {
        const updateValues = async () => {
            if (!selectedRoute || !selectedToken || !allRoutes || swapInProgress.current)
                return;
            const updatedRoute = allRoutes.find(r => r.name === selectedRoute.name);
            const updatedToken = updatedRoute?.tokens?.find(t => t.symbol === selectedToken.symbol);
            if (updatedToken === selectedToken)
                return;
            if (updatedRoute && updatedToken) {
                await updateForm({
                    formDataKey: currencyFieldName,
                    formDataValue: updatedToken,
                    shouldValidate: true,
                    setFieldValue
                });
            }
        };
        updateValues();
    }, [selectedRoute, selectedToken, allRoutes, direction, setFieldValue]);
    const handleSelect = useCallback(async (route, token) => {
        swapInProgress.current = false;
        await updateForm({
            formDataKey: currencyFieldName,
            formDataValue: token,
            shouldValidate: true,
            setFieldValue
        });
        await updateForm({
            formDataKey: direction,
            formDataValue: route,
            shouldValidate: true,
            setFieldValue
        });
    }, [currencyFieldName, direction]);
    const showBalance = !hideBalance && !isExchange && (direction === 'to' || values.depositMethod === 'wallet');
    const triggerDataAttr = direction === "from" ? "from-route-picker" : "to-route-picker";
    const triggerClassName = "group-[.exchange-picker]:bg-secondary-500 py-1.5 px-2 group-[.exchange-picker]:py-2! group-[.exchange-picker]:px-3! active:animate-press-down group-[.exchange-picker]:active:animate-none";
    return (_jsxs("div", { className: clsx("flex flex-col self-end relative items-center", className), children: [onTriggerClick ? (_jsx("div", { className: "rounded-2xl flex items-center relative w-full z-10 self-end", children: _jsx("button", { type: "button", onClick: onTriggerClick, "data-attr": triggerDataAttr, className: clsx("rounded-2xl focus-peer:ring-primary focus-peer:border-secondary-400 focus-peer:border focus-peer:ring-1 focus:outline-none disabled:cursor-not-allowed relative grow flex items-center text-left justify-bottom w-full px-2 pr-0 bg-secondary-300 hover:bg-secondary-200 font-semibold", triggerClassName), children: _jsx(SelectedRouteDisplay, { route: selectedRoute, token: selectedToken, placeholder: "Select token" }) }) })) : (_jsxs(Selector, { children: [_jsx(SelectorTrigger, { "data-attr": triggerDataAttr, disabled: false, className: triggerClassName, children: _jsx(SelectedRouteDisplay, { route: selectedRoute, token: selectedToken, placeholder: "Select token" }) }), _jsx(SelectorContent, { isLoading: isLoading, searchHint: "Search", header: _jsx(PickerWalletConnect, { direction: direction }), ref: ref, children: ({ closeModal }) => (_jsx(Content, { onSelect: (r, t) => { handleSelect(r, t); closeModal(); }, searchQuery: searchQuery, setSearchQuery: setSearchQuery, rowElements: routeElements, direction: direction, selectedRoute: selectedRoute?.name, selectedToken: selectedToken?.symbol })) })] })), showBalance &&
                _jsx(Balance, { values: values, direction: direction, minAllowedAmount: minAllowedAmount, maxAllowedAmount: maxAllowedAmount, quoteTokenPrices: quoteTokenPrices ?? quote })] }));
};
export default RoutePicker;
